export enum EMenuNames {
  COURT = "Court",
  APPEAL = "Appeal",
  DOCUMENT = "Document",
  PARTY = "Party",
  OTHER = "Other",
  MAPPING = "Mapping",
  COURT_STAFF_REGISTRATION = "CourtStaffRegistration",
  COURT_STAFF_ROLES = "CourtStaff",
  COURTROOM_BLOCK = "CourtRoomBlock",
  SESSION_DETAILS = "SessionDetails",
  JUSTICE_PANEL_ASSIGNMENT = "JusticePanelAssignment",
  COURT_PROPERTIES = "CourtProperties",
  INTERNAL_DOCUMENTS = "InternalDocuments",
  DOCUMENTS_RECEPTION = "DocumentsReception",
  MY_ASSIGNMENTS = "MyAssignments",
  PARTIES = "Parties",
  JUSTICE_REASSIGNMENT = "JusticeReAssignment",
  FEE_ASSESSMENT = "FeeAssesment",
  FEE_PAYMENT = "FeePayment",
  HEARING_SCHEDULE = "HearingSchedule",
  HEARING_SUMMONS = "HearingSummons",
  HEARING_PROCESS = "HearingProcess",
  OATH_PROCESS = "OathProcess",
  CLOSE_TASKS = "CloseTasks",
  LIST_OF_FILES = "ListOfFiles",
  APPEAL_SHEET = "AppealSheet",
  APPEAL_HEARING_SCHEDULE = "CaseHearingSchedule",
  APPEAL_HISTORY = "CaseHistory",
  APPEAL_HISTORY_FOR_COUNSEL = "CounselListForAParty",
  CURRENT_PHASE_OF_APPEALS = "CurrentPhaseOfAppeals",
  APPEAL_SUMMARY_BASED_ON_APPEAL_TYPE = "CaseSummaryBasedOnCaseType",
  ACTION_STATUS_ON_APPEALS = "ActionStatusOnCasesAstAt",
  APPEALS_BY_LOWER_COURT = "AppealsByLowerCourt",
  APPEALS_BY_PARTY_NAME = "AppealsByPartyName",
  APPEALS_PENDING_FOR_HEARING = "CasesPendingforHearing",
  CAUSELIST = "CauseList",
  DOCUMENTS_RECEIVED_FOR_APPEAL = "DocumentsReceivedForAppeal",
  LIST_OF_APPEALS_BY_JUSTICE = "ListOfCasesByJudge",
  LIST_OF_APPEALS_HANDLED_BY_JUSTICE = "ListOfCasesHandledByJustice",
  LIST_OF_APPEALS_RECEIVED = "ListOfCasesReceived",
  LIST_OF_JUSTICES_THAT_HANDLED_APPEAL = "ListOfJusticesThatHandledCase",
  APPEAL_DETAILS_BASED_ON_PARTY_NAME = "AppealDetailsBasedOnPartyName",
  APPEAL_STATISTICS = "CaseStatistics",
  STAFF_ASSIGNMENT_HISTORY = "StaffAssignmentHistory",
  LIST_OF_USERS_AND_ROLES = "ListOfUsersAndRoles",
  BACKLOG_APPEALS = "BacklogAppeals",
  LIST_OF_APPEALS_BY_STATUS = "ListOfAppealsByStatus",
  AUDIT_TRAIL = "AuditTrail",
  ROLE_MENU_MAPPING = "RoleMenuMapping",
  NEWS_AND_EVENTS = "NewsAndEvents",
  HOLIDAYS = "Holidays",
  RESET_PASSWORD = "Reset Password",
  PASSWORD_HASHING_UTILITY = "PwdHashingUtility",
  FORCE_LOG_OFF = "ForceLogoff",
  ABSENCE_TYPES = "AbsenceTypes",
  ADMINISTRATIVE_UNIT_TYPES = "AdminUnitTypes",
  ADMINISTRATIVE_UNITS = "AdminUnits",
  COURT_DIVISIONS = "CourtDivisions",
  SESSION_MASTER = "SessionMaster",
  JUSTICE_PANEL = "JusticePanel",
  STAFF_TYPES = "StaffTypes",
  LOWER_COURTS = "LowerCourts",
  APPEAL_TYPES = "CaseTypes",
  APPEAL_PHASE_TYPES = "CasePhTypes",
  APPEAL_STATUS = "CaseStatus",
  FEE_COMPONENT_TYPES = "FeeComponentTypes",
  RESTRICTION_LEVELS = "RestrictionLevels",
  EVENT_TYPES = "EventTypes",
  TASK_TYPES = "TaskTypes",
  DOCUMENT_DIRECTIONS = "DocumentDirections",
  DOCUMENT_TYPES = "DocumentTypes",
  RECEIPT_TYPES = "ReceiptTypes",
  CONTACT_TYPES = "ContactInfoTypes",
  ID_STRUCTURE_TYPES = "IdStructureTypes",
  PARTY_ROLES = "PartyRoles",
  PARTY_TYPES = "PartyTypes",
  PAYMENT_TYPES = "PaymentTypes",
  CURRENCIES = "Currencies",
  COURT_DIVISIONS_APPEAL_TYPES = "CourtDivisionsAppealTypes",
  APPEAL_TYPES_DOCUMENT_TYPES = "AppealTypesDocTypes",
  DOCUMENT_TYPES_EVENT_TYPES = "DocTypesEventTypes",
  EVENT_TYPES_TASK_TYPES_ROLES = "EventTypesTaskTypesRoles",
  DOCUMENT_TYPES_APPEAL_PHASE_TYPES = "DocTypeAppealPhType",
  APPEAL_STATUS_APPEAL_PHASE_TYPES = "AppealStatusAppealPhTypes",
  STAFF_ROLES_DOCUMENT_TYPES = "StaffRolesDocumentTypes",
  PARTY_ROLES_DOCUMENT_TYPES = "PartyRolesDocumentTypes",
  TASK_TYPES_EVENT_TYPES = "TaskTypesEventTypes",
  HEARING_NOTICE = "HearingSummons",
  COUNSEL_REPORT_BY_DATE = "CounselReportByDate",
  LIST_OF_BACKLOG_APPEALS = "ListOfBacklogAppeals",
  CASE = "Case",
  COURT_BLOCK = "CourtRoomBlock",
  JUDGE_PANEL_ASSIGNMENT = "JusticePanelAssignment",
  STAFF_COURT_ASSIGNMENT = "StaffCourtAssignment",
  DOCUMENTS_ADOPTION = "DocumentsAdoption",
  COURT_PANEL_ASSIGNMENT = "CourtOrPanelAssignment",
  HEARING_SCHEDULE_LOWER = "HearingScheduleforTrialCourts",
  CASE_SHEET = "AppealSheet",
  ACTION_STATUS_ON_CASES = "ActionStatusOnCasesAstAt",
  CASE_DURATION = "CaseDuration",
  CASE_HEARING_SCHEDULE = "CaseHearingSchedule",
  CASE_HISTORY = "CaseHistory",
  CASE_HISTORY_FOR_COUNSEL = "CounselListForAParty",
  CURRENT_PHASE_OF_CASES = "CurrentPhaseOfAppeals",
  CASE_PROGRESS = "CaseProgress",
  CASES_PENDING_FOR_HEARING = "CasesPendingforHearing",
  DATE_ALERT_BY_LAST_DOCUMENT_RECORDED = "DateAlertByLastDocumentRecorded",
  PENDING_TASKS_TILL_DATE = "PendingTasksTillDate",
  DOCUMENTS_RECEIVED_FOR_CASE = "DocumentsReceivedForAppeal",
  JUDGE_PANEL_FOR_CASES = "JusticePanelForAppeals",
  LIST_OF_CASES_BY_JUDGE = "ListOfCasesByJudge",
  LIST_OF_CASES_HANDLED_BY_JUDGE = "ListOfCasesHandledByJustice",
  LIST_OF_CASES_RECEIVED = "ListOfCasesReceived",
  LIST_OF_JUDGES_THAT_HANDLED_CASE = "ListOfJusticesThatHandledCase",
  CASE_STATISTICS = "CaseStatistics",
  LIST_OF_MOTIONS_FILED_IN_CASE = "ListOfMotionsFiledInCase",
  BACKLOG_CASES = "BacklogAppeals",
  PENDING_CASE_STATISTICS = "PendingCaseStatistics",
  RELOAD_CACHE = "ReloadCache",
  JUDGE_PANEL = "JusticePanel",
  CASE_TYPES = "CaseTypes",
  CASE_PHASE_TYPES = "CasePhTypes",
  CASE_STATUS = "CaseStatus",
  COURT_DIVISIONS_CASE_TYPES = "CourtDivisionsAppealTypes",
  CASE_TYPES_DOCUMENT_TYPES = "AppealTypesDocTypes",
  DOCUMENT_TYPES_CASE_PHASE_TYPES = "DocTypeAppealPhType",
  CASE_STATUS_CASE_PHASE_TYPES = "AppealStatusAppealPhTypes",
  REPORTS = "Reports",
  MONITORING = "Monitoring",
  JUDGEMENT_SCHEDULE = "JudgementSchedule"


};

export interface IMenuItem {
  id: string;
  label: string;
  routerLink: string;
  subMenu?: IMenuItem[]; // Add submenus
}

export const MAIN_MENUS: IMenuItem[] = [
  { label: 'Documents Reception', routerLink: 'documents-reception', id: EMenuNames.DOCUMENTS_RECEPTION },
  { label: 'My Assignments', routerLink: 'my-assignments', id: EMenuNames.MY_ASSIGNMENTS },
  { label: 'Court / panel Assignment', routerLink: 'court-panel-assignment', id: EMenuNames.COURT_PANEL_ASSIGNMENT },
  { label: 'Hearing Schedule', routerLink: 'hearing-schedule', id: EMenuNames.HEARING_SCHEDULE },
  { label: 'Hearing Schedule', routerLink: 'hearing-schedule', id: EMenuNames.HEARING_SCHEDULE_LOWER },
  { label: 'Hearing Process', routerLink: 'hearing-process', id: EMenuNames.HEARING_PROCESS },
  { label: 'Case Sheet', routerLink: 'case-sheet', id: EMenuNames.CASE_SHEET },
  { label: 'Parties', routerLink: 'parties', id: EMenuNames.PARTIES },
  { label: 'List Of Files', routerLink: 'list-of-files', id: EMenuNames.LIST_OF_FILES },
  { label: 'Close Tasks', routerLink: 'close-task', id: EMenuNames.CLOSE_TASKS },
  { label: 'Fee Payment', routerLink: 'fee-payment', id: EMenuNames.FEE_PAYMENT },
  { label: 'Hearing Notice', routerLink: 'hearing-notice', id: EMenuNames.HEARING_NOTICE },
  { label: 'Judgement Schedule', routerLink: 'judgement-schedule', id: EMenuNames.JUDGEMENT_SCHEDULE },
  { id: EMenuNames.MONITORING, label: 'Monitoring', routerLink: 'monitoring' },
  { id: EMenuNames.JUSTICE_REASSIGNMENT, label: 'Justice Reassignment', routerLink: 'justice-reassignment' },



];
